import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Hero } from "../components/home/Hero";
import { About } from "../components/home/About";
import { Companies } from "../components/home/Companies";
import { Ecosystem } from "../components/home/Ecosystem";
import { Platforms } from "../components/home/Platforms";
import { WhySadja } from "../components/home/WhySadja";
import { Roadmap } from "../components/home/Roadmap";
import { AssetStrategy } from "../components/home/AssetStrategy";
import { Experience } from "../components/home/Experience";
import { Investors } from "../components/home/Investors";
import { Leadership } from "../components/home/Leadership";
import { Contact } from "../components/home/Contact";
import { Marquee } from "../components/Marquee";
import { scrollToSection } from "../components/Navbar";

export default function HomePage() {
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const target = location.state?.scrollTo;
        if (target) {
            const t = setTimeout(() => scrollToSection(target, navigate, "/"), 150);
            return () => clearTimeout(t);
        }
        return undefined;
    }, [location.state, navigate]);

    return (
        <main data-testid="home-page">
            <Hero />
            <Marquee />
            <About />
            <Companies />
            <Ecosystem />
            <Platforms />
            <WhySadja />
            <Roadmap />
            <AssetStrategy />
            <Experience />
            <Investors onPartner={() => scrollToSection("contact", navigate, "/")} />
            <Leadership />
            <Contact />
        </main>
    );
}
